module.exports = __webpack_public_path__ + "media/images/icons/country_flags/ad-5a5f3d81a3d9016099f029923554107c.svg";